export const brands = [
  { codigo: '46', descripcion: 'VOLKSWAGEN' },
  { codigo: '32', descripcion: 'PEUGEOT' },
  { codigo: '36', descripcion: 'RENAULT' },
  { codigo: '12', descripcion: 'CHEVROLET' },
  { codigo: '18', descripcion: 'FORD' },
  { codigo: '17', descripcion: 'FIAT' },
  { codigo: '11', descripcion: 'CITROEN' },
  // { codigo: '797', descripcion: 'A.F.F.' },
  { codigo: '1', descripcion: 'ACURA' },
  { codigo: '21', descripcion: 'AEOLUS' },
  { codigo: '63', descripcion: 'AGRALE' },
  { codigo: '2', descripcion: 'ALEKO' },
  { codigo: '3', descripcion: 'ALFA ROMEO' },
  { codigo: '4', descripcion: 'ARO' },
  // { codigo: '791', descripcion: 'ARTIC' },
  { codigo: '5', descripcion: 'ASIA' },
  { codigo: '71', descripcion: 'ASIA CAMION' },
  // { codigo: '128', descripcion: 'ASTON MARTIN' },
  // { codigo: '1001', descripcion: 'ATV' },
  { codigo: '6', descripcion: 'AUDI' },
  { codigo: '60', descripcion: 'AUSTIN' },
  { codigo: '7', descripcion: 'AUTOBIANCHI' },
  { codigo: '118', descripcion: 'BAIC' },
  // { codigo: '795', descripcion: 'BEDFORD' },
  { codigo: '78', descripcion: 'BELAVTOMAZ' },
  { codigo: '61', descripcion: 'BERTONE' },
  { codigo: '58', descripcion: 'BLAC' },
  // { codigo: '837', descripcion: 'BLACKSTONE' },
  { codigo: '8', descripcion: 'BMW' },
  { codigo: '1000', descripcion: 'CADILLAC' },
  // { codigo: '803', descripcion: 'CAMION + 10TN' },
  { codigo: '108', descripcion: 'CHERY' },
  { codigo: '72', descripcion: 'CHEVROLET CAM.' },
  { codigo: '13', descripcion: 'CHRYSLER' },
  { codigo: '14', descripcion: 'DACIA' },
  { codigo: '15', descripcion: 'DAEWOO' },
  { codigo: '16', descripcion: 'DAIHATSU' },
  { codigo: '93', descripcion: 'DAIHATSU CAMION' },
  { codigo: '112', descripcion: 'DFM' },
  { codigo: '119', descripcion: 'DFSK' },
  { codigo: '89', descripcion: 'DIMEX' },
  { codigo: '9', descripcion: 'DKW' },
  { codigo: '798', descripcion: 'DODGE' },
  { codigo: '117', descripcion: 'DS AUTOMOBILES' },
  { codigo: '54', descripcion: 'ENIAK' },
  { codigo: '69', descripcion: 'F.E.R.E.S.A.' },
  { codigo: '51', descripcion: 'FERRARI' },
  { codigo: '73', descripcion: 'FORD CAMION' },
  { codigo: '115', descripcion: 'FOTON' },
  { codigo: '79', descripcion: 'G.A.Z.' },
  // { codigo: '792', descripcion: 'GAUSS' },
  { codigo: '116', descripcion: 'GEELY' },
  // { codigo: '799', descripcion: 'GMC' },
  { codigo: '121', descripcion: 'GREAT WALL' },
  { codigo: '64', descripcion: 'GROSSPAL' },
  { codigo: '52', descripcion: 'HAM-JIANG' },
  { codigo: '122', descripcion: 'HAVAL' },
  { codigo: '99', descripcion: 'HEIBAO' },
  { codigo: '961', descripcion: 'HERO' },
  { codigo: '123', descripcion: 'HERO' },
  { codigo: '80', descripcion: 'HINO' },
  { codigo: '19', descripcion: 'HONDA' },
  { codigo: '49', descripcion: 'HUMMER' },
  { codigo: '20', descripcion: 'HYUNDAI' },
  { codigo: '59', descripcion: 'I.K.A. RENAULT' },
  // { codigo: '796', descripcion: 'IKA RENAULT' },
  { codigo: '87', descripcion: 'INTERNATIONAL' },
  { codigo: '22', descripcion: 'ISUZU' },
  { codigo: '41', descripcion: 'IVECO' },
  { codigo: '81', descripcion: 'IZH' },
  { codigo: '98', descripcion: 'JAC' },
  { codigo: '23', descripcion: 'JAGUAR' },
  { codigo: '68', descripcion: 'JINBEI' },
  { codigo: '113', descripcion: 'JMC' },
  { codigo: '82', descripcion: 'KAMAZ' },
  { codigo: '83', descripcion: 'KENWORTH' },
  { codigo: '24', descripcion: 'KIA' },
  { codigo: '74', descripcion: 'KIA CAMION' },
  { codigo: '25', descripcion: 'LADA' },
  { codigo: '129', descripcion: 'LAMBERT' },
  { codigo: '53', descripcion: 'LANCIA' },
  { codigo: '84', descripcion: 'LIAZ' },
  { codigo: '114', descripcion: 'LIFAN' },
  // { codigo: '109', descripcion: 'LINCOLN' },
  { codigo: '111', descripcion: 'MACK' },
  { codigo: '67', descripcion: 'MAESTRO' },
  { codigo: '55', descripcion: 'MAHINDRA' },
  { codigo: '102', descripcion: 'MASERATI' },
  { codigo: '26', descripcion: 'MAZDA' },
  { codigo: '90', descripcion: 'MAZDA CAMION' },
  { codigo: '28', descripcion: 'MERCEDES BENZ' },
  { codigo: '75', descripcion: 'MERCEDES BENZ C' },
  { codigo: '27', descripcion: 'MERCURY' },
  { codigo: '62', descripcion: 'METRO' },
  { codigo: '106', descripcion: 'MINI COOPER' },
  { codigo: '29', descripcion: 'MITSUBISHI' },
  { codigo: '91', descripcion: 'MITSUBISHI CAM.' },
  { codigo: '77', descripcion: 'NAKAI (CHANGAN)' },
  { codigo: '30', descripcion: 'NISSAN' },
  { codigo: '92', descripcion: 'NISSAN CAMION' },
  { codigo: '125', descripcion: 'OLDSMOBILE' },
  { codigo: '31', descripcion: 'OPEL' },
  // { codigo: '793', descripcion: 'PACKARD' },
  { codigo: '94', descripcion: 'PIAGGIO' },
  { codigo: '105', descripcion: 'PLYMOUTH' },
  { codigo: '33', descripcion: 'POLONEZ' },
  { codigo: '124', descripcion: 'PONTIAC' },
  { codigo: '35', descripcion: 'PORSCHE' },
  { codigo: '48', descripcion: 'PROTON' },
  { codigo: '65', descripcion: 'RANQUEL' },
  // { codigo: '56', descripcion: 'RASTROJERO' },
  { codigo: '70', descripcion: 'RENAULT CAMION' },
  { codigo: '107', descripcion: 'ROLLS ROYCE' },
  { codigo: '37', descripcion: 'ROVER-LAND ROV.' },
  { codigo: '38', descripcion: 'SAAB' },
  { codigo: '103', descripcion: 'SANTANA' },
  { codigo: '95', descripcion: 'SANXING' },
  { codigo: '50', descripcion: 'SCANIA' },
  { codigo: '39', descripcion: 'SEAT' },
  { codigo: '120', descripcion: 'SHINERAY' },
  // { codigo: '104', descripcion: 'SIAM DI TELLA' },
  { codigo: '40', descripcion: 'SKODA' },
  { codigo: '110', descripcion: 'SMART' },
  { codigo: '101', descripcion: 'SPACE' },
  { codigo: '96', descripcion: 'STAR (3-STAR)' },
  { codigo: '42', descripcion: 'SUBARU' },
  { codigo: '43', descripcion: 'SUZUKI' },
  { codigo: '853', descripcion: 'SYM' },
  // { codigo: '794', descripcion: 'SYM' },
  { codigo: '57', descripcion: 'TATA' },
  { codigo: '76', descripcion: 'TATA CAMION' },
  { codigo: '44', descripcion: 'TAVRIA' },
  { codigo: '45', descripcion: 'TOYOTA' },
  { codigo: '85', descripcion: 'UAZ' },
  { codigo: '10', descripcion: 'VALIANT' },
  { codigo: '66', descripcion: 'VOLKSWAGEN CAM.' },
  { codigo: '47', descripcion: 'VOLVO' },
  { codigo: '88', descripcion: 'VOLVO CAMION' },
  { codigo: '100', descripcion: 'WULING MOTORS' },
  { codigo: '97', descripcion: 'YANTAI' },
  { codigo: '86', descripcion: 'YUEJIN' },
  // { codigo: '900', descripcion: 'ACOPLADO Y SEMIRREMOLQUE' },
  // { codigo: '909', descripcion: 'AUTOELEVADOR' },
  // { codigo: '907', descripcion: 'BANTAM' },
  { codigo: '946', descripcion: 'CAN AM' },
  // { codigo: '906', descripcion: 'CASA RODANTE' },
  { codigo: '1240', descripcion: 'CHANGAN' },
  { codigo: '839', descripcion: 'GAMMA' },
  { codigo: '999', descripcion: 'INDIAN' },
  // { codigo: '905', descripcion: 'MAQUINARIA NO RURAL CON PROPULSION' },
  // { codigo: '904', descripcion: 'MAQUINARIA NO RURAL SIN PROPULSION' },
  // { codigo: '903', descripcion: 'MAQUINARIA RURAL CON PROPULSION' },
  // { codigo: '902', descripcion: 'MAQUINARIA RURAL SIN PROPULSION' },
  // { codigo: '126', descripcion: 'MG' },
  { codigo: '847', descripcion: 'POLARIS' },
  // { codigo: '1500', descripcion: 'TIANJIN' },
  // { codigo: '901', descripcion: 'TRACTOR RURAL' },
  // { codigo: '908', descripcion: 'TRAILER' },
  { codigo: '911', descripcion: 'YAMAHA' }
];
